<template>
  <div>
    <base-breadcrumb :routes="routes" />
    <base-card class="container px-4 pt-1">
      <slot />
      <br>
      <div v-if="loading">
        <base-loading :show="loading" />
      </div>
      <edit-preview
        v-if="previewContent"
        :content="previewContent"
      />
    </base-card>
  </div>
</template>

<script>
import EditPreview from '@/components/Widgets/EditPreview';

export default {
  name: 'SentSummary',
  components: {
    EditPreview,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    preview: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    cloning: {
      type: Boolean,
      default: false,
    },
    isLibrary: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showOutreachReport: false,
    };
  },
  computed: {
    routes() {
      let route = 'Sent';
      if (this.item.display === 'scheduled') {
        route = 'Scheduled';
      } else if (this.isLibrary) {
        route = 'Library';
      }

      return [{
        name: 'Edits',
        link: '/entries',
      },
      {
        name: route,
      },
      ];
    },
    previewUrl() {
      return `${this.apiRoot()}/render_edit/${this.item.pk}/`;
    },
    previewContent() {
      return this.$store.state.entries?.preview ?? null;
    },
  },
  watch: {
    item() {
      if (this.item === null || this.item === undefined) return;
      this.$store.dispatch('entries/getPreview', { id: this.item.pk, intro: !this.isLibrary });
    },
  },
  mounted() {
    // let showIntro = true;
    // if (this.item !== null && this.item !== undefined) {
    //   showIntro = this.item.pk === this.$store.state.entries.item.pk && this.$store.state.entries.item.owner === this.$store.state.account.user.profile.url;
    // }
    this.$store.dispatch('entries/getPreview', { id: this.item.pk, intro: !this.isLibrary });
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 975px;
}

.cell {
  background: #F9F7F6;
  border-radius: 5px;

  &__button {
    border: 1px solid $black;
    min-width: 96px;
    font-size: 11px;
    font-family: $font-family-sans-serif-medium;
    border-radius: 0;
    padding-left: 0;
    padding-right: 0;
    justify-content: center;
    margin-right: 0;
    background: #F9F7F6;
  }
}

.disable-clicks {
  cursor: wait;
}

.solid-border {
  border-top: 1px solid #646464;
}

</style>
